import { connect } from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import AccreditationRequestsByGroupList from "./AccreditationRequestsByGroupList";
import {
    MODAL_ACCREDITATION_REQUESTS_REJECT, MODAL_ACCREDITATION_REQUESTS_SET_AG,
    showModal
} from "../../../reducers/common/activeModal";
import {
    fetchGetAccreditationRequestsByAGs, getUnreferencedAccreditationRequestsData,
    loadingUnreferencedAccreditationRequests, onChangeUnreferencedAccreditationRequestAG,
    onGetAccreditationRequestsFilteredByAGs, onRemoveUnreferencedAccreditationRequestAG, setFilterAG
} from "../../../reducers/accreditation/unreferencedAccreditationRequests";

const mapStateToProps = state => {
    return {
        loading: loadingUnreferencedAccreditationRequests(state),
        translation: getTranslation(state),
        data: getUnreferencedAccreditationRequestsData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(setFilterAG(null));
            dispatch(fetchGetAccreditationRequestsByAGs());
        },
        onAccreditationRequestsReject: () => dispatch(showModal({modalKey: MODAL_ACCREDITATION_REQUESTS_REJECT})),
        onAccreditationRequestsSetAG: () => dispatch(showModal({modalKey: MODAL_ACCREDITATION_REQUESTS_SET_AG})),
        onFilterByGroup: (group) => {
            dispatch(onGetAccreditationRequestsFilteredByAGs(group));
        },
        onReject: (data) => {
            dispatch(onRemoveUnreferencedAccreditationRequestAG(data));
        },
        onSetAccreditationGroup: (group, data) => {
            dispatch(onChangeUnreferencedAccreditationRequestAG(group, data));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(AccreditationRequestsByGroupList);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationRequestsByGroupList/AccreditationRequestsByGroupList.container.js